export default "__VITE_ASSET__CxkTXLTt__"